import React from 'react';
import Modal from './Modal';

// Gestylter Ersatz für window.confirm — konsistent mit dem restlichen UI,
// barrierefrei über den Modal-Rahmen (Fokus-Falle, Escape = Abbrechen).
// Optional eine zweite, nicht-destruktive Aktion (secondaryLabel/onSecondary) —
// z.B. "Zuweisung behalten" neben "Leads freigeben".
export default function ConfirmDialog({ title, message, confirmLabel = 'Löschen', onConfirm, secondaryLabel, onSecondary, onCancel }) {
  return (
    <Modal onClose={onCancel} label={title} style={{ maxWidth: 460 }}>
      <h2 style={{ marginBottom: 10 }}>{title}</h2>
      <p style={{ fontSize: 14, color: '#374151', whiteSpace: 'pre-line' }}>{message}</p>
      <div className="form-actions" style={{ marginTop: 20, flexWrap: 'wrap' }}>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>Abbrechen</button>
        {secondaryLabel && (
          <button type="button" className="btn btn-primary" onClick={onSecondary}>{secondaryLabel}</button>
        )}
        <button type="button" className="btn btn-danger" onClick={onConfirm} autoFocus>{confirmLabel}</button>
      </div>
    </Modal>
  );
}
